<template>
  <div class="zl-dialog-table">
    <component
      :is="tableComponent"
      ref="table"
      class="zl-dialog-table-table"
      table-type="index"
      :[tableName]="$table"
      :list="list"
      v-bind="$attrs"
      @sort-change="sortChange"
    />
    <div v-if="useApi" class="zl-dialog-table-pagination">
      <el-pagination
        background
        hide-on-single-page
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.current"
        :page-size="pagination.size"
        :page-sizes="[10, 20, 30, 50]"
        :total="pagination.total"
        @current-change="currentChange"
        @size-change="sizeChange"
      />
    </div>
  </div>
</template>

<script>
const orderMap = {
  ascending: 'asc',
  descending: 'desc'
}
export default {
  props: {
    // eslint-disable-next-line
    $table: {
      type: Object,
      default: () => ({})
    },
    row: {
      type: Object,
      default: () => ({})
    },
    params: {
      type: Function,
      default: () => ({})
    },
    api: {
      type: null,
      default: null
    },
    getData: {
      type: Function,
      default: async() => []
    }
  },
  data() {
    return {
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {},
      dataList: [],
      apiList: []
    }
  },
  computed: {
    tableName() {
      return '$table'
    },
    tableComponent() {
      return this.$table.tpl()
    },
    useApi() {
      return !!this.api
    },
    list() {
      return this.api ? this.apiList : this.dataList
    }
  },
  mounted() {
    this.search()
  },
  methods: {
    getParams() {
      if (!this.api) return {}
      const params = this.params(this.row, this.list)
      const { current, size } = this.pagination
      const condition = { ...params, ...this.sort }
      return { condition, current, size }
    },
    async search() {
      this.dataList = await this.getData(this.row)
      if (!this.api) return
      const params = this.getParams()
      const info = await this.api(params)
      this.apiList = info.records || info
      this.pagination.total = info.total || 0
    },
    sortChange({ prop, order }) {
      this.sort.field = prop
      this.sort.order = orderMap[order]
      this.pagination.current = 1
      this.search()
    },
    currentChange(current) {
      this.pagination.current = current
      this.search()
    },
    sizeChange(size) {
      this.pagination.current = 1
      this.pagination.size = size
      this.search()
    },
    // 编辑相关
    validate(callback) {
      this.$refs.table.validate(callback)
    }
  }
}
</script>

<style lang="scss" scoped>
.zl-dialog-table {
  margin: 0 -10px;
  &-pagination {
    padding-top: 10px;
    text-align: right;
  }
}
</style>
